const _ = require('lodash')
const overrideClientSpecMapScriptsFromQuery = require('santa-main-r/lib/lib/common/overrideClientSpecMapScriptsFromQuery').default

// copied from https://github.com/wix-private/santa-core/blob/master/santa-main-r/src/lib/common/getQueryUtils.js
const getParameterFromQuery = (query, name) => {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
    const regex = new RegExp(`[\\?&]${name}=([^&#]*)`)
    const results = regex.exec(query)
    return results && results[1] ? decodeURIComponent(results[1]).replace(/\+/g, ' ') : ''
}

module.exports = {
    applyGradualRolloutOverrides: clientSpecMap => {
        _(clientSpecMap)
            .filter(entry => _.isPlainObject(_.get(entry, 'appFields.gradualRolloutOverrides')))
            .forEach(entry => {
                _.forEach(entry.appFields.gradualRolloutOverrides, (value, key) => _.set(entry, key, value))
            })
    },
    overrideClientSpecMapScriptsFromQuery: (rawUrl, serviceTopology, clientSpecMap) => {
        const componentScriptsOverrideParam = getParameterFromQuery(rawUrl, 'widgetsUrlOverride')
        const viewerScriptOverrideParam = getParameterFromQuery(rawUrl, 'viewerPlatformOverrides')
        const controllerScriptsOverrideParam = getParameterFromQuery(rawUrl, 'controllersUrlOverride')
        const overridePlatformBaseUrlsParam = getParameterFromQuery(rawUrl, 'overridePlatformBaseUrls')

        overrideClientSpecMapScriptsFromQuery({
            clientSpecMap,
            viewerScriptOverrideParam,
            controllerScriptsOverrideParam,
            componentScriptsOverrideParam,
            overridePlatformBaseUrlsParam,
            scriptsLocation: serviceTopology.staticServerUrl
        })
    },
    removeApps: (clientSpecMap, disableAppsString) => {
        if (!disableAppsString) {
            return clientSpecMap
        }
        const apps = disableAppsString.toLowerCase().split(',')
        return _.omitBy(clientSpecMap, ({appDefinitionId, type}) => {
            if (type === 'siteextension') {
                return apps.includes(appDefinitionId) || apps.includes('wixcode'.toLowerCase())
            }
            return apps.includes(appDefinitionId)
        })
    }
}
